<template>
  <div>

      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">

                <div class="block-header bg-primary-dark">
                      <ul  class="block-options">

                          <li v-if="carSharingEnableFlag">
                              <button type="button" @click="shareEntity()" ><i class="h1 fa fa-share-alt fa-2x push-15-r "></i></button>
                          </li>

                          <li v-if="flagDisplayCar===0">
                              <button type="button" @click="toggleDisplayCar()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                          </li>
                          <li v-if="flagDisplayCar">
                              <button  type="button" @click="toggleDisplayCar()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                          </li>
                      </ul>
                  <h2 class="h3 block-title" @click="toggleDisplayCar()"><i class="fa fa-car fa-1x push-5-r "></i>{{tempoBundle.cars[carIndex].ReferenceName}}</h2>
                </div>


                <div v-if="flagDisplayCar" class="block-content">

                  <div class="row">
                    <div class="col-xs-12">

                        <!-- Static Labels -->
                        <div class="block">
                          <div class="col-xs-12">
                            <div class="form-group">
                                <label class="col-xs-12">{{ textLabelRefrenceName[actualLanguage] }}</label>
                                <div class="col-sm-12">
                                    <input v-model="tempoBundle.cars[carIndex].ReferenceName" class="form-control"  placeholder="Entrez votre information\Write your information">
                                </div>
                            </div>
                          </div>

                          <div class="col-xs-12">
                            <hr></hr>
                          </div>

                          <div v-if="carConfigViewFlag" class="col-xs-12">
                              <h4 ><i class="fa fa-gear"></i> Configuration</h4>

                              <div class="col-xs-12 col-md-6">
                                <div class="form-group">
                                    <label class="col-xs-12">{{ textLabelName[actualLanguage] }}</label>
                                    <div class="col-sm-12">
                                        <input v-model="tempoBundle.cars[carIndex].CarData.carInfo.carName" class="form-control" type="test" id="lock1-password" name="lock1-password" placeholder="Entrez votre information">
                                    </div>
                                </div>

                                <div class="col-xs-12">
                                  <div v-if="tempoBundle.cars[carIndex].CarData.carInfo.carName" class="form-group">
                                    <label for="manufacturier">{{ labelFieldManufacturer[actualLanguage] }}</label>
                                    <select class="form-control" @change='onManufacturerChange' v-model="tempoBundle.cars[carIndex].CarData.carInfo.manufacturer" size="1">
                                      <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                      <option v-for="manufacturer in manufacturers" :value="manufacturer">{{manufacturer}}</option>
                                    </select>
                                  </div>
                                </div>

                              </div>

                              <div v-if="tempoBundle.cars[carIndex].CarData.carInfo.carPictureFile" class="col-xs-12 col-md-6">
                                <div class="form-group">
                                  <p><img class = "img-responsive"  width="200px" :src="`cars/${tempoBundle.cars[carIndex].CarData.carInfo.carPictureFile}` | s3Image"></p>
                                </div>
                              </div>

                              <div v-if="evseFlag" class="col-xs-12">

                                <div class="col-xs-6 col-md-4 col-lg-3">
                                  <div v-if="filteredYears.length" class="form-group">
                                    <label for="manufacturier">{{ labelFieldLevel[actualLanguage] }}</label>
                                    <select class="form-control" @change='onYearChange' v-model="tempoBundle.cars[carIndex].CarData.carInfo.year" size="1">
                                      <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                      <option v-for="year in filteredYears" :value="year">{{year}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="col-xs-6 col-md-4 col-lg-3">
                                  <div v-if="filteredModels.length" class="form-group">
                                    <label for="manufacturier">{{ labelFieldEVSEBrand[actualLanguage] }}</label>
                                    <select class="form-control" @change='onModelChange' v-model="tempoBundle.cars[carIndex].CarData.carInfo.model">
                                      <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                      <option v-for="model in filteredModels" :value="model">{{model}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="col-xs-6 col-md-4 col-lg-3">
                                  <div v-if="filteredColors.length" class="form-group">
                                    <label for="manufacturier">{{ labelFieldEVSEModel[actualLanguage] }}</label>
                                    <select class="form-control" @change='onColorChange'  v-model="tempoBundle.cars[carIndex].CarData.carInfo.color">
                                      <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                      <option v-for="color in filteredColors" :value="color">{{color}}</option>
                                    </select>
                                  </div>
                                </div>

                              </div>


                              <div v-else class="col-xs-12">

                                <div class="col-xs-12 col-md-6 col-lg-3">
                                  <div v-if="filteredYears.length" class="form-group">
                                    <label for="manufacturier">{{ labelFieldEVYear[actualLanguage] }}</label>
                                    <select class="form-control" @change='onYearChange' v-model="tempoBundle.cars[carIndex].CarData.carInfo.year" size="1">
                                      <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                      <option v-for="year in filteredYears" :value="year">{{year}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="col-xs-12 col-md-6 col-lg-3">
                                  <div v-if="filteredModels.length" class="form-group">
                                    <label for="manufacturier">{{ labelFieldEVModel[actualLanguage] }}</label>
                                    <select class="form-control" @change='onModelChange'  v-model="tempoBundle.cars[carIndex].CarData.carInfo.model">
                                      <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                      <option v-for="model in filteredModels" :value="model">{{model}}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="col-xs-12 col-md-6 col-lg-3">
                                  <div v-if="filteredColors.length" class="form-group">
                                    <label for="manufacturier">{{ labelFieldEVColor[actualLanguage] }}</label>
                                    <select class="form-control" @change='onColorChange'  v-model="tempoBundle.cars[carIndex].CarData.carInfo.color">
                                      <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                      <option v-for="color in filteredColors" :value="color">{{color}}</option>
                                    </select>
                                  </div>
                                </div>


                                <div class="col-xs-12 col-md-6 col-lg-3">
                                    <div v-if="filteredColors.length" class="form-group">
                                      <label for="deviceSelect">{{ labelFieldEVConsumption[actualLanguage] }}</label>
                                      <input v-model="tempoBundle.cars[carIndex].CarData.carInfo.averageWhPerKm" class="form-control">
                                    </div>
                                </div>

                              </div>

                              <div  v-if="filteredColors.length" class="col-xs-12">

                                <div v-if="displayDevicePortConfig" class="col-xs-12 col-md-6 col-lg-6">
                                  <h5 >{{ textLabelDevicePort[actualLanguage] }}</h5>
                                  <div class="col-xs-12 col-md-12 col-lg-6">
                                    <div v-if="tempoBundle.cars[carIndex].CarData.carInfo.color" class="form-group">
                                        <label for="deviceSelect">{{ labelFieldLinkModule[actualLanguage] }}</label>
                                        <select  class="form-control"  v-model="tempoBundle.cars[carIndex].CarData.linkedDevice">
                                          <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                          <option v-for="device in tempoBundle.devices" :value="device.DeviceData.deviceId">{{device.DeviceData.deviceId}}</option>
                                        </select>
                                    </div>
                                  </div>

                                  <div class="col-xs-12 col-md-12 col-lg-6">
                                    <div v-if="tempoBundle.cars[carIndex].CarData.linkedDevice" class="form-group">
                                      <label for="deviceSelect">{{ labelFieldLinkPort[actualLanguage] }}</label>
                                      <select class="form-control"   v-model="tempoBundle.cars[carIndex].CarData.linkedPort">
                                        <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
                                        <option v-for="model in [1,2,3,4,5,6]" :value="model">{{model}}</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <div v-if="displayDevicePortConfig" class="col-xs-12 col-md-6 col-lg-6">
                                  <h5 >{{ textLabelChargeDetectionRange[actualLanguage] }}</h5>
                                  <div class="col-xs-12 col-md-12 col-lg-6">
                                      <div v-if="tempoBundle.cars[carIndex].CarData.linkedDevice" class="form-group">
                                        <label for="deviceSelect">{{ labelFieldSessDetecMinThld[actualLanguage] }}</label>
                                        <input v-model="tempoBundle.cars[carIndex].CarData.sessionDetectionParam[0].minPower" class="form-control">
                                      </div>
                                  </div>

                                  <div class="col-xs-12 col-md-12 col-lg-6">
                                      <div v-if="tempoBundle.cars[carIndex].CarData.linkedDevice" class="form-group">
                                        <label for="deviceSelect">{{ labelFieldSessDetecMaxThld[actualLanguage] }}</label>
                                        <input v-model="tempoBundle.cars[carIndex].CarData.sessionDetectionParam[0].maxPower" class="form-control">
                                      </div>
                                  </div>
                                </div>

                              </div>


                          </div>

                          <div v-if="bundleConfigEditFlag" class="col-xs-12">
                              <div class="col-xs-12 items-push" >
                                <div class="col-xs-12 col-md-6">
                                  <button type="button" style="color:white" @click="confirmRemoveCar()" class="btn btn-danger" name="buttonDeletePlanItem2">
                                    <spinner size="small" v-if="carIsDeleting"></spinner>
                                    <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonLabelDelete[actualLanguage] }}</span></button>
                                </div>

                                <div v-if="tempoBundle.cars[carIndex].CarData.linkedPort" class="col-xs-12 col-md-6">
                                  <p><button v-if="carConfigEditFlag" @click="saveCarModifications()" type="button" class="btn btn-success align-right" name="button">
                                    <spinner size="small" v-if="carIsSaving"></spinner>
                                    <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ buttonLabelSaveModification[actualLanguage] }}</span></button></p>
                                </div>
                              </div>                          
                          </div>

                        </div>

                        <!-- END block -->
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>

  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters, mapActions} from 'vuex'
import CarForm from '@/views/configuration/CarForm'
import Spinner from '../../components/Spinner.vue'
import ConfigSharingList from './SubComponent/ConfigSharingList'

export default {
  props: ['carIndex'],
  components: {
    Spinner,
    CarForm,
    ConfigSharingList
  },
  data() {
    return {
      tempoBundle : {},
      displayDataTable : false,
      flagDisplayCar : 0,
      alertShowAddButton: true,
      carIsSaving : false,
      carIsDeleting : false,

      evseFlag: false,
      filteredYears: [],
      filteredModels: [],
      filteredColors: [],
      filteredCarPool: [],
      carModel: {
        manufacturer: '',
        color: '',
        year: '',
        model: '',
        carName: '',
        linkedDevice: '',
        linkedPort:   '',
        averageWhPerKm: '',
        // averageLtPerKm: 10.2
      },


      actualLanguage : "FR",
      labelFieldEvName: {FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name'},
      labelFieldManufacturer: {FR: 'Manufacturier', EN: 'Manufacturer'},
      labelFieldSelect: {FR: 'Choisir', EN: 'Select'},
      labelFieldLevel: {FR: 'Niveau', EN: 'Level'},
      labelFieldEVSEBrand: {FR: 'Marque de borne', EN: 'EVSE Brand'},
      labelFieldEVSEModel: {FR: 'Type/Modèle', EN: 'Model'},
      labelFieldEVYear: {FR: 'Année', EN: 'Year'},
      labelFieldEVModel: {FR: 'Modèle', EN: 'Model'},
      labelFieldEVColor: {FR: 'Couleur', EN: 'Color'},
      labelFieldLinkModule: {FR: 'Module accosié à la recharge', EN: 'Linked module'},
      labelFieldLinkPort: {FR: 'Port associé à la recharge', EN: 'Linked port'},
      labelFieldEVConsumption: {FR: 'Consommation (Wh/km)', EN: 'Consumption (Wh/km)'},
      labelFieldSessDetecMinThld: {FR: 'Plage detection min. (W)', EN: 'Detection range min. (W)'},
      labelFieldSessDetecMaxThld: {FR: 'Plage detectin max. (W)', EN: 'Detection range max. (W)'},
      labelFieldButtonSave: {FR: 'Sauvegarder', EN: 'Save'},
      labelFieldButtonDelete: {FR: 'Supprimer', EN: 'Delete'},


      textLabelRefrenceName: {FR: "Nom de référence", EN: 'Referencen name'},
      textLabelName: {FR: "Nom", EN: 'Name'},
      textLabelDevicePort: {FR: "Module et port associé", EN: 'Module and linked port'},
      textLabelChargeDetectionRange: {FR: "Plage de détection de recharge", EN: 'Charge detection range'},
      buttonLabelDelete: {FR: "Supprimer", EN: 'Delete'},
      buttonLabelSaveModification: {FR: "Enregistrer les modification", EN: 'Save modifications'},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du véhicule ou chargeur : ", EN: 'Confirm deletion of EV or EVSE : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},
      messageConfirmCarManufacturerChange:{FR: "Confirmer la modification de modèle de VE? (Ce changement permet de modifier votre définition de VE mais les données d'économies sont sauvegardées).", EN: 'Confirm electric vehicule model? (This modification allow you to change your EV descrition but caculated savings are kept)'},



      carConfigViewFlag : false,
      carConfigEditFlag : false,
      carConfigDeleteFlag : false,
      carSharingEnableFlag : false,

      bundleConfigEditFlag : false,

      displayDevicePortConfig : false,

    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','parentContainer']),
    ...mapState('carsStore', ['cars', 'manufacturers']),
    ...mapState('overlayStore', ['overlayParameters']),
  },
  watch: {
    actualBundle(){
      //console.log('---CAR Actual Bundle Watcher----')
        this.reloadTempoBundle()
    },
  },

  methods: {
  ...mapActions('overlayStore', ['showModal']),
   toggleDisplayCar(){
      this.flagDisplayCar = ~this.flagDisplayCar
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },

    onManufacturerChange() {
      if(this.tempoBundle.cars[this.carIndex].CarData.carInfo.model != ''){
        var changeCarFlag = window.confirm(this.messageConfirmCarManufacturerChange[this.actualLanguage]);
      }else{var changeCarFlag = true}

      //console.log(changeCarFlag)
      if(changeCarFlag == true){
          this.resetData();
          if(this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer =="Borne de recharge") 
          {this.evseFlag = true;}else{this.evseFlag = false;}

          return this.$store.dispatch('carsStore/getManufacturerInfos', { manufacturer: this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer })
          .then((response) => {
            this.filteredCarPool = response.data
            this.filteredYears   = _.uniq(_.map(response.data, (object) => { return object.year; }))
            return Promise.resolve();
          })
      }
    },

    onYearChange() {
      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer,
        year: this.tempoBundle.cars[this.carIndex].CarData.carInfo.year
      }).then((response) => {
        this.filteredCarPool = response.data
        this.filteredModels = _.uniq(_.map(response.data, (object) => { return object.model; }))

        return Promise.resolve();
      })
    },

    onModelChange() {
      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer,
        year: this.tempoBundle.cars[this.carIndex].CarData.carInfo.year,
        model: this.tempoBundle.cars[this.carIndex].CarData.carInfo.model,
        whPerKm: this.carModel.averageWhPerKm,
      }).then((response) => {
        this.filteredCarPool = response.data
        //console.log('Filtered Car Pool')
        //console.log(this.filteredCarPool)
        this.tempoBundle.cars[this.carIndex].CarData.carInfo.averageWhPerKm = this.filteredCarPool[0].averageWhPerKm
        this.tempoBundle.cars[this.carIndex].CarData.carInfo.averageLtPerKm = this.filteredCarPool[0].averageLtPerKm
        
        this.filteredColors = _.uniq(_.map(response.data, (object) => { return object.color; }))
        return Promise.resolve();
      })
    },

    onColorChange(){
        for(var n=0;n<this.filteredCarPool.length;n++){
            if (this.filteredCarPool[n].color==this.tempoBundle.cars[this.carIndex].CarData.carInfo.color){
                this.tempoBundle.cars[this.carIndex].CarData.carInfo.carPictureFile = this.filteredCarPool[n].carPictureFile
                this.tempoBundle.cars[this.carIndex].CarData.carInfo.carId = this.filteredCarPool[n].carId
            }
        }
    },



//
    resetData() {
      this.filteredYears = []
      this.filteredModels = []
      this.filteredColors = []
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.year = ''
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.color = ''
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.model = ''
      this.tempoBundle.cars[this.carIndex].CarData.linkedDevice   = ''
      this.tempoBundle.cars[this.carIndex].CarData.linkedPort = ''
      this.tempoBundle.cars[this.carIndex].CarData.carInfo.carPictureFile = ''
    },


    saveCarModifications() {
        this.carIsSaving = true
        var requestData = { 'postAction':'SaveCarModification',
                            'bundleId': this.tempoBundle.bundle_id,
                            'carIndex': this.carIndex,
                            'carData':this.tempoBundle.cars[this.carIndex],
                            }
        //console.log(requestData)                  
        this.$store.dispatch('sessionStore/postCar', requestData)
            .then((response) => {
              //console.log(response.data)
              this.channelIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                this.$store.dispatch('sessionStore/reloadActualBundle')
                this.alertShowAddButton=true
                this.carIsSaving = false
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage] )}
            })       
    },


    confirmRemoveCar(){
          var FlagProcessToDelete = false
          
          var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.tempoBundle.cars[this.carIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.carIsDeleting = true
              var requestData = { 'postAction':'RemoveCarFromBundle',
                                  'carIndex':this.carIndex,
                                  'carId':this.tempoBundle.cars[this.carIndex].CarData.carId,
                                  'bundleId':this.actualBundle.bundle_id,
                                  'parentContainer':this.parentContainer,
                                  }
              //console.log(requestData) 
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                    this.carIsDeleting = false
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')

                      this.$store.dispatch('sessionStore/reloadActualBundle')
                      this.alertShowAddButton=true
                      }
                      else{ window.alert(this.messagePostFail[this.actualLanguage] )}
                  })       
          }

    },



  
    computeSumBundleAlert() {
      this.sumAlertActualBundle = this.actualBundle.alerts.length

    },

    computeSumChannelAlert(){
      this.sumAlertActualChannel = 0
      for(var n=0;n<this.actualBundle.alerts.length;n++){
            if(this.actualBundle.alerts[n].AlertData.linked_channel[0]==this.tempoBundle.channels[this.channelIndex].ChannelData.channelId){
              this.sumAlertActualChannel++
            }
        }
    },

    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage de VE ou borne", EN: 'EV or EVSE sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Car',
                        'entityId':this.tempoBundle.cars[this.carIndex].CarData.carId,
                        'entityReferenceName':this.tempoBundle.cars[this.carIndex].ReferenceName,
                        'displayCarOptions':true,
                        'displayAlertOptions':false,
                        'displayChannelOptions':false,
                        'displayDeviceOptions':false,
                        'displayBundleOptions':false,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },

    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value
          //console.log('Value Found')
          }
        }
        return value
    },


    validateIfCarDeviceInDeviceList(){
      var returnValue = false
      for (var n = 0; n < this.tempoBundle.devices.length; n++){
        if(this.tempoBundle.cars[this.carIndex].CarData.linkedDevice == this.tempoBundle.devices[n].DeviceData.deviceId){
          returnValue = true
        }
      }

      if(this.tempoBundle.cars[this.carIndex].CarData.linkedDevice==''){
        returnValue = true
      }

      return returnValue
    },


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    if(this.tempoBundle.cars[this.carIndex].CarData.carInfo.manufacturer =="Borne de recharge") 
    {this.evseFlag = true;}else{this.evseFlag = false;}

    this.filteredYears = [this.tempoBundle.cars[this.carIndex].CarData.carInfo.year]
    this.filteredModels = [this.tempoBundle.cars[this.carIndex].CarData.carInfo.model]
    this.filteredColors = [this.tempoBundle.cars[this.carIndex].CarData.carInfo.color]

    if(this.tempoBundle.cars[this.carIndex].CarData.carInfo.model=="TBD"){this.resetData()}

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}

    this.carConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions,'carConfigView')
    this.carConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions,'carConfigEdit')
    this.carConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions,'carConfigDelete')
    this.carSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.cars[this.carIndex].CarData.permissions,'carSharingEnable')

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle,'bundleConfigEdit')


    this.displayDevicePortConfig = this.validateIfCarDeviceInDeviceList()

  },

  beforeMount(){
    this.reloadTempoBundle()
  }

}
</script>

<style lang="css">
  .h1 {font-size: 24px;}
  .h2 {font-size: 20px;}
  .h3 {font-size: 16px;}
  .h4 {font-size: 14px;}
  .h5 {font-size: 12px;}

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {
      .h1 {font-size: 18px;}
      .h2 {font-size: 16px;}
      .h3 {font-size: 14px;}
      .h4 {font-size: 10px;}
      .h5 {font-size: 8px;}
  }
</style>



// WEBPACK FOOTER //
// ConfigCar.vue?1904ab24